import { EmptyStateContext } from "./empty-state.context";
import type { EmptyStateProps } from "./types-empty-state";
import { useEmptyState } from "./use-empty-state";
import { EmptyStateView } from "./view-empty-state";

export function EmptyStateRoot({ children, ...options }: EmptyStateProps) {
  const viewModel = useEmptyState(options);

  return (
    <EmptyStateContext.Provider value={viewModel}>
      <EmptyStateView
        className={viewModel.className}
        style={viewModel.style}
        size={viewModel.size}
        testId={viewModel.testId}
        rest={viewModel.rest}
      >
        {children}
      </EmptyStateView>
    </EmptyStateContext.Provider>
  );
}
EmptyStateRoot.displayName = "EmptyState.Root";
